import { FormattedMessage, PDFPreviewer, useMelioIntl } from '@melio/ar-domain';
import { Group, SectionBanner, Text } from '@melio/penny';
import { forwardRef, useBoolean } from '@melio/platform-utils';

import { InvoiceFormLayout } from '../../../layouts';

export type PreviewInvoiceScreenProps = {
  error?: PlatformError;
  onClose: VoidFunction;
  previewContent: string;
  isLoading: boolean;
};

export const PreviewInvoiceScreen = forwardRef<PreviewInvoiceScreenProps>(
  ({ isLoading, previewContent, onClose, error, ...props }, ref) => {
    const [isBannerDismissed, dismissBanner] = useBoolean();
    const { formatMessage } = useMelioIntl();

    const SectionBannerComp = () =>
      error && !isBannerDismissed ? (
        <SectionBanner
          data-testid="preview-invoice-error-banner"
          description={formatMessage('ar.invoiceLifecycle.activities.previewInvoice.failure.text')}
          showCloseIcon
          variant="critical"
          onClose={dismissBanner.on}
        />
      ) : null;

    return (
      <InvoiceFormLayout
        variant="10Columns"
        isLoading={isLoading}
        onClose={onClose}
        data-component="PreviewInvoiceScreen"
        data-testid="preview-invoice-screen"
        {...props}
        ref={ref}
      >
        <Group variant="vertical" alignItems="flex-start" spacing="l">
          <Group variant="vertical" alignItems="flex-start" width="full">
            <Text textStyle="heading1Semi" data-testid="preview-invoice-header-text">
              <FormattedMessage id="ar.invoiceLifecycle.activities.previewInvoice.title.text"></FormattedMessage>
            </Text>
            <SectionBannerComp />
          </Group>
          {!error && <PDFPreviewer previewContent={previewContent} />}
        </Group>
      </InvoiceFormLayout>
    );
  }
);

PreviewInvoiceScreen.displayName = 'PreviewInvoiceScreen';
